export default function ErrorPlaceholder() {
  return (
    <div className="bg-white card-promo rounded shadow px-2 py-3 p-md-3 text-align-center">
      <p className="subhead-1 text-primary">
        Unable to load events
      </p>
      <p className="text-dark-subtle mb-1">
        Please check back soon.
      </p>
    </div>
  );
}